import React from 'react';
import styled from 'styled-components';

interface ModalActionsProps {
  children?: React.ReactNode;
}

interface StyledComponentProps {
  children?: React.ReactNode;
}

const StyledModalActions = styled.div<StyledComponentProps>`
  align-items: center;
  background-color: ${(props) => props.theme.color.grey[100]}00;
  display: flex;
  justify-content: center;
  height: 96px;
  margin: ${(props) => props.theme.spacing[4]}px ${(props) => -props.theme.spacing[4]}px
    ${(props) => -props.theme.spacing[4]}px;
  padding: 0 ${(props) => props.theme.spacing[4]}px;
`;

const StyledModalAction = styled.div<StyledComponentProps>`
`;

const StyledSpacer = styled.div`
  width: ${(props) => props.theme.spacing[4]}px;
`;

const ModalActions = ({ children }: ModalActionsProps) => {
  if (!children) return null;

  const renderChildren = () => {
    const childrenArray = React.Children.toArray(children);
    return childrenArray.map((child, index) => (
      <React.Fragment key={index}>
        <StyledModalAction>
          <>{child}</>
        </StyledModalAction>
        {index < childrenArray.length - 1 && <StyledSpacer />}
      </React.Fragment>
    ));
  };

  return (
    <StyledModalActions>
      {renderChildren()}
    </StyledModalActions>
  );
};

ModalActions.defaultProps = {
  children: null,
};

export default ModalActions;
